/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AffectsProduction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function AffectsProduction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/Content/Content/Charge/AffectsProduction"
  
}) {
let chargeAffectingProductionReportValueData = fromData.useDataFormat({ viewPath,
context: 'charge',
path: 'affecting_production_report',
format: fromFormat.booleanToYesNo,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="charge.affecting_production_report"
 format="/Data/format.js booleanToYesNo"
 text={chargeAffectingProductionReportValueData}
 size="small"
/>
{children}
</React.Fragment>)
}